import React, { Component } from 'react';
import '../css/dataTables.css';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";
import { ApiClient } from '../libs/apiClient';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../libs/utils/Const';
import { connect } from 'react-redux';

let headers = [
    { title: '#' },
    { title: 'Posición de ubicación' },
];
let apiClient = ApiClient.getInstance();
class ListLocationsModal extends Component {

    closeItems = async () => {
        const { cleanData } = this.props;
        cleanData();

        $('#listLocations').modal('hide');
    }

    selectLocations = data => {
        const { LineNum, selectLocation } = this.props;
        selectLocation(data, LineNum)
    };

    searchLocationMod = async (location = '', PageNumber, locationsPage = null) => {
        const { enableSpinner, refreshLocations, newOrderModel, DocBinView = false, auxWhsCode = '' } = this.props;
        // let ToWhsCode = newOrderModel.ToWhsCode || '';
        let ToWhsCode = !DocBinView ? newOrderModel.ToWhsCode || '' : auxWhsCode || '';
        let getLocationResponse;
        if (location !== '') {
            getLocationResponse = await apiClient.getLocations(location, PageNumber, locationsPage, ToWhsCode);

        } else {
            enableSpinner(true);
            getLocationResponse = await apiClient.getLocations(location, PageNumber, locationsPage, ToWhsCode);
            enableSpinner(false);

        }

        if (getLocationResponse.status === SERVICE_RESPONSE.SUCCESS) {
            refreshLocations(getLocationResponse.data.results, getLocationResponse.data.totalPage, location);
        }
    };

    searchLocations = async (location, PageNumber, locationsPage) => {
        await this.searchLocationMod(location, PageNumber, locationsPage);
    };

    render() {
        const { data, totalPage, newOrderModel } = this.props;
        let searchLocation = newOrderModel.searchLocation || '';

        // if(data.length === 0){
        //     return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="listLocations"></div>;
        // }

        return (
            <div>
                <div className="modal fade bd-example-modal-md modal-open scroll" style={{ zIndex: 30 }} data-backdrop="false" role="dialog" id="listLocations" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-md modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de Ubicaciones</h4>
                                <button type="button" className="close" onClick={this.closeItems} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{ marginBottom: 0 }}>
                                                    <tbody>
                                                        <DataTablesCreate
                                                            data={data}
                                                            totalPage={totalPage}
                                                            headers={headers} view={"listLocationsAssignment"} action={this.selectLocations} search={this.searchLocations} searchInTable={searchLocation} />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeItems}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListLocationsModal);